// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_fG","advertDetailContactItem__link":"c-n_fH","advertDetailContactItem__stub":"c-n_fJ"};